import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import CurrentImagePreview from '../../../Components/CurrentImagePreview'
import { eventTypeSchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, event_type, packages = [] }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${event_type.name}`}
    >
      <BackLink href="/manage/event_types">Back to Event Types</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={eventTypeSchema}
          resource="event_type"
          endpoint={`/manage/event_types/${event_type.id}`}
          method="patch"
          backLink="/manage/event_types"
          submitLabel="Save Changes"
          defaultValues={{
            name: event_type.name || '',
            icon: event_type.icon || '',
            tagline: event_type.tagline || '',
            description: event_type.description || '',
            active: event_type.active ?? true,
            image: null,
            seo_title: event_type.seo_title || '',
            seo_description: event_type.seo_description || '',
            package_ids: event_type.package_ids || []
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="tagline"
                label="Tagline"
                errors={errors}
                placeholder="One line shown under the name"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={3}
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="icon"
                label="Icon"
                errors={errors}
                placeholder="e.g. 💍"
                hint="Optional. An emoji or icon key."
              />

              <CurrentImagePreview
                url={event_type.image_url}
                alt={event_type.name}
              />

              <FormFieldController
                control={control}
                name="image"
                label={event_type.image_url ? "Replace Image" : "Image"}
                type="file"
                accept="image/*"
                hint={event_type.image_url ? "Leave empty to keep current image" : undefined}
                errors={errors}
              />

              {packages.length > 0 && (
                <FormFieldController
                  control={control}
                  name="package_ids"
                  label="Packages"
                  type="checkboxGroup"
                  options={packages.map(p => ({ value: p.id, label: p.name }))}
                  hint="Packages available for this occasion"
                  errors={errors}
                />
              )}

              <FormFieldController
                control={control}
                name="seo_title"
                label="Search Title"
                errors={errors}
                placeholder={`e.g. ${event_type.name} at ${account.name}`}
                hint="Optional. Shown as the page title in Google. Leave blank to auto-generate from the occasion, club name and location."
              />

              <FormFieldController
                control={control}
                name="seo_description"
                label="Search Description"
                type="textarea"
                rows={2}
                errors={errors}
                hint="Optional. The snippet under the title in search results (aim for under 160 characters). Leave blank to auto-generate."
              />

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                hint="Uncheck to hide this event type from guests"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
